/* QUILTZA ürün sayfası: varyant, adet, akordeon, galeri, sabit panel, mobil yapışkan satın al, son bakılanlar. Vanilla JS. */
(function () {
  if (customElements.get('qz-product')) return;

  var RECENT_KEY = 'qz-recently-viewed';

  class QzProduct extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var data = this.querySelector('[data-qz-variants]');
      try { this.variants = data ? JSON.parse(data.textContent) : []; } catch (e) { this.variants = []; }
      this.fieldsets = Array.prototype.slice.call(this.querySelectorAll('[data-qz-option]'));
      this.idInput = this.querySelector('input[name="id"]');
      this.cta = this.querySelector('[data-qz-cta]');
      this.ctaLabel = this.querySelector('[data-qz-cta-label]');
      this.info = this.querySelector('[data-qz-info]');

      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      this.markAvailability();
      this.initGallery();
      this.initSticky();
      this.initStickyBuy();
      this.recordView();
    }

    /* ---------- Varyant ---------- */
    selected() {
      return this.fieldsets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    match(opts) {
      return this.variants.filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      });
    }
    onChange(e) {
      var fs = e.target.closest('[data-qz-option]');
      if (fs) {
        var idx = parseInt(fs.dataset.qzOption, 10);
        var opts = this.selected();
        var exact = this.match(opts)[0];
        if (!exact) {
          var only = opts.map(function (o, i) { return i === idx ? o : null; });
          var cands = this.match(only);
          exact = cands.filter(function (v) { return v.available; })[0] || cands[0];
          if (exact) this.applyOptions(exact.options);
        }
        this.update(exact);
        this.markAvailability();
        return;
      }
      if (e.target.matches('.qz-qty__input')) this.clampQty(e.target);
    }
    applyOptions(options) {
      this.fieldsets.forEach(function (fs, i) {
        fs.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === options[i]; });
      });
    }
    markAvailability() {
      var sel = this.selected();
      var self = this;
      this.fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (inp) {
          var opts = sel.slice();
          opts[idx] = inp.value;
          var found = self.match(opts);
          var label = fs.querySelector('label[for="' + inp.id + '"]');
          var avail = found.some(function (v) { return v.available; });
          if (label) {
            label.classList.toggle('is-unavailable', found.length > 0 && !avail);
            label.title = found.length && !avail ? self.dataset.strSoldout : '';
          }
          inp.disabled = self.match(opts.map(function (o, i) { return i === idx ? o : null; })).length === 0;
        });
      });
    }
    update(v) {
      if (!v) {
        if (this.cta) { this.cta.disabled = true; this.ctaLabel.textContent = this.dataset.strUnavailable; }
        if (this.stickyBtn) { this.stickyBtn.disabled = true; this.stickyBtn.textContent = this.dataset.strUnavailable; }
        return;
      }
      if (this.idInput) {
        this.idInput.value = v.id;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var now = this.querySelector('[data-qz-price-now]');
      if (now) now.textContent = v.price;
      var was = this.querySelector('[data-qz-price-was]');
      if (v.compare) {
        if (!was) {
          was = document.createElement('s');
          was.setAttribute('data-qz-price-was', '');
          now.after(was);
        }
        was.textContent = v.compare;
      } else if (was) { was.remove(); }

      var stock = this.querySelector('[data-qz-stock]');
      if (stock) {
        stock.dataset.status = v.status;
        stock.querySelector('[data-qz-stock-text]').textContent = v.msg;
      }
      if (this.cta) {
        this.cta.disabled = !v.available;
        this.cta.removeAttribute('aria-disabled');
        this.ctaLabel.textContent = v.available ? this.dataset.strAdd : this.dataset.strSoldout;
        this.ctaLabel.classList.remove('hidden');
        var som = this.cta.querySelector('.sold-out-message');
        if (som) som.classList.add('hidden');
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
      if (v.media) this.showMedia(v.media);
      this.syncSticky(v);
    }

    /* ---------- Mobil yapışkan satın al çubuğu ---------- */
    initStickyBuy() {
      this.sticky = this.querySelector('[data-qz-sticky-buy]');
      if (!this.sticky || !this.cta || !('IntersectionObserver' in window)) return;
      var self = this;
      this.stickyBtn = this.sticky.querySelector('[data-qz-sticky-cta]');
      this.stickyPrice = this.sticky.querySelector('[data-qz-sticky-price]');
      this.stickyVariant = this.sticky.querySelector('[data-qz-sticky-variant]');
      if (this.stickyBtn) {
        this.stickyBtn.addEventListener('click', function () {
          if (self.cta && !self.cta.disabled) self.cta.click();
        });
      }
      var mq = window.matchMedia('(max-width: 989px)');
      this._stickyIO = new IntersectionObserver(function (entries) {
        var en = entries[0];
        self.setStickyBuy(mq.matches && !en.isIntersecting && en.boundingClientRect.top < 0);
      });
      this._stickyIO.observe(this.cta);
      mq.addEventListener('change', function (m) { if (!m.matches) self.setStickyBuy(false); });
    }
    setStickyBuy(on) {
      if (!this.sticky || this._stickyOn === on) return;
      this._stickyOn = on;
      this.sticky.classList.toggle('is-visible', on);
      if (on) { this.sticky.removeAttribute('aria-hidden'); this.sticky.removeAttribute('inert'); }
      else { this.sticky.setAttribute('aria-hidden', 'true'); this.sticky.setAttribute('inert', ''); }
      if (on) document.documentElement.style.setProperty('--qz-sticky-h', this.sticky.offsetHeight + 'px');
      document.body.classList.toggle('qz-has-sticky-buy', on);
    }
    syncSticky(v) {
      if (!this.sticky || !v) return;
      if (this.stickyPrice) this.stickyPrice.textContent = v.price;
      if (this.stickyVariant && this.fieldsets.length) this.stickyVariant.textContent = v.options.join(' / ');
      if (this.stickyBtn) {
        this.stickyBtn.disabled = !v.available;
        this.stickyBtn.textContent = v.available ? this.dataset.strAdd : this.dataset.strSoldout;
      }
    }

    /* ---------- Adet ---------- */
    clampQty(input) {
      var min = parseInt(input.min, 10) || 1;
      var max = input.max ? parseInt(input.max, 10) : Infinity;
      var val = parseInt(input.value, 10);
      if (isNaN(val) || val < min) val = min;
      if (val > max) val = max;
      input.value = val;
    }

    onClick(e) {
      var q = e.target.closest('[data-qz-qty]');
      if (q) {
        var input = q.parentElement.querySelector('.qz-qty__input');
        var step = parseInt(input.step, 10) || 1;
        var val = parseInt(input.value, 10) || 0;
        input.value = q.dataset.qzQty === 'plus' ? val + step : val - step;
        this.clampQty(input);
        return;
      }
      var acc = e.target.closest('.qz-accordion__trigger');
      if (acc) { this.toggleAccordion(acc); return; }
      var thumb = e.target.closest('[data-qz-thumb]');
      if (thumb) { this.showMedia(thumb.dataset.qzThumb); return; }
      var zoom = e.target.closest('[data-qz-zoom]');
      if (zoom) { this.openLightbox(zoom.dataset.qzZoom, zoom); return; }
      if (e.target.closest('[data-qz-lightbox-close]')) this.closeLightbox();
    }

    /* ---------- Akordeon ---------- */
    toggleAccordion(btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.dataset.open = open ? 'true' : 'false';
      if (open) panel.removeAttribute('inert'); else panel.setAttribute('inert', '');
      var self = this;
      window.setTimeout(function () { self.checkSticky(); }, 320);
    }

    /* ---------- Galeri ---------- */
    initGallery() {
      this.track = this.querySelector('[data-qz-track]');
      this.counter = this.querySelector('[data-qz-count]');
      this.lightbox = this.querySelector('[data-qz-lightbox]');
      if (!this.track || !this.counter || !('IntersectionObserver' in window)) return;
      var self = this;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > 0.6) self.counter.textContent = en.target.dataset.index;
        });
      }, { root: this.track, threshold: [0.6] });
      this.track.querySelectorAll('.qz-gallery__item').forEach(function (it) { io.observe(it); });
    }
    showMedia(id) {
      if (!this.track) return;
      this.querySelectorAll('[data-qz-thumb]').forEach(function (t) {
        if (String(t.dataset.qzThumb) === String(id)) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      var item = this.track.querySelector('[data-media-id="' + id + '"]');
      if (!item) return;
      if (window.matchMedia('(max-width: 989px)').matches) {
        this.track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      } else if (this.track.firstElementChild !== item) {
        this.track.insertBefore(item, this.track.firstElementChild);
      }
    }
    openLightbox(src, trigger) {
      if (!this.lightbox || typeof this.lightbox.showModal !== 'function') { window.open(src, '_blank'); return; }
      this._zoomTrigger = trigger;
      this.lightbox.querySelector('[data-qz-lightbox-img]').src = src;
      this.lightbox.showModal();
      var self = this;
      this.lightbox.addEventListener('close', function () { if (self._zoomTrigger) self._zoomTrigger.focus(); }, { once: true });
    }
    closeLightbox() { if (this.lightbox && this.lightbox.open) this.lightbox.close(); }

    /* ---------- Sabit panel ---------- */
    initSticky() {
      if (this.dataset.sticky !== 'true' || !this.info) return;
      var self = this;
      this.checkSticky();
      window.addEventListener('resize', function () { self.checkSticky(); }, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(function () { self.checkSticky(); }).observe(this.info);
    }
    checkSticky() {
      if (this.dataset.sticky !== 'true' || !this.info) return;
      var desktop = window.matchMedia('(min-width: 990px)').matches;
      var header = 0;
      document.querySelectorAll('.shopify-section-group-header-group, sticky-header, header').forEach(function (el) {
        var pos = getComputedStyle(el).position;
        var r = el.getBoundingClientRect();
        if ((pos === 'sticky' || pos === 'fixed') && r.top <= 1 && r.bottom > header) header = r.bottom;
      });
      this.style.setProperty('--qz-header-h', Math.round(header) + 'px');
      var top = (parseInt(getComputedStyle(this).getPropertyValue('--qz-sticky-top'), 10) || 24) + header;
      var fits = this.info.scrollHeight + top + 24 < window.innerHeight;
      this.info.classList.toggle('is-sticky', desktop && fits);
    }

    /* ---------- Son bakılanlar ---------- */
    recordView() {
      var handle = this.dataset.handle;
      if (!handle) return;
      try {
        var list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]').filter(function (h) { return h !== handle; });
        list.unshift(handle);
        localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12)));
      } catch (e) {}
    }
  }
  customElements.define('qz-product', QzProduct);

  /* Öneriler: Shopify Product Recommendations API */
  if (!customElements.get('qz-recommendations')) {
    customElements.define('qz-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this._loaded || !this.dataset.url) return;
        this._loaded = true;
        var self = this;
        var load = function () {
          fetch(self.dataset.url)
            .then(function (r) { return r.text(); })
            .then(function (text) {
              var html = new DOMParser().parseFromString(text, 'text/html');
              var fresh = html.querySelector('qz-recommendations');
              if (fresh && fresh.innerHTML.trim().length) {
                self.innerHTML = fresh.innerHTML;
                self.hidden = false;
              }
            })
            .catch(function () {});
        };
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (en) {
            if (en[0].isIntersecting) { io.disconnect(); load(); }
          }, { rootMargin: '0px 0px 400px 0px' });
          io.observe(this.hidden ? this.parentElement : this);
        } else { load(); }
      }
    });
  }

  /* Son bakılan ürünler: localStorage + Section Rendering API (veri dışarı gönderilmez) */
  if (!customElements.get('qz-recently-viewed')) {
    customElements.define('qz-recently-viewed', class extends HTMLElement {
      connectedCallback() {
        if (this._loaded) return;
        this._loaded = true;
        var list = [];
        try { list = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) {}
        var current = this.dataset.current;
        var limit = parseInt(this.dataset.limit, 10) || 4;
        list = list.filter(function (h) { return h && h !== current; }).slice(0, limit);
        if (!list.length) return;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var grid = this.querySelector('[data-qz-recent-grid]');
        var self = this;
        Promise.all(list.map(function (h) {
          return fetch(root + 'products/' + encodeURIComponent(h) + '?section_id=qz-card')
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (t) {
              if (!t) return '';
              var d = new DOMParser().parseFromString(t, 'text/html');
              var s = d.querySelector('.shopify-section');
              return s && s.innerHTML.trim() ? '<li>' + s.innerHTML + '</li>' : '';
            })
            .catch(function () { return ''; });
        })).then(function (items) {
          var html = items.join('');
          if (!html) return;
          grid.innerHTML = html;
          self.hidden = false;
        });
      }
    });
  }
})();
